export const AssetTypesFormat = {
  'multi-asset_and_balanced': 'Multi-Asset and Balanced',
  equity: 'Equity',
  fixed_income: 'Fixed Income',
  fund_of_funds: 'Fund of Funds',
  target_date: 'Target Date'
};

export const ObjectivesFormat = {
  asset_allocation: 'Asset Allocation',
  balanced: 'Balanced',
  bond: 'Bond',
  equity_income: 'Equity Income',
  growth: 'Growth',
  growth_and_income: 'Growth and Income',
  managed_risk: 'Managed Risk',
  portfolio_series: 'Portfolio Series',
  retirement_target_date: 'Retirement Target Date'
};

export const ShareClassesFormat = {
  1: '1',
  '1a': '1A',
  2: '2',
  4: '4',
  p1: 'P1',
  p2: 'P2'
};

export const TimeSpanFormat = {
  quarterly: 'quarterly',
  monthly: 'monthly'
};

export default {
  AssetTypesFormat,
  ObjectivesFormat,
  ShareClassesFormat,
  TimeSpanFormat
};
